import { render } from "./SiteHazardRowLabel.vue?vue&type=template&id=476f4c5c"
import script from "./SiteHazardRowLabel.vue?vue&type=script&lang=js"
export * from "./SiteHazardRowLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__